var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { INLINE_STYLES } from '../helper';
var IconS24InfoCircle24 = function (_a) {
    var inline = _a.inline, title = _a.title, rest = __rest(_a, ["inline", "title"]);
    return (React.createElement("svg", __assign({ width: 24, height: 24, viewBox: "0 0 32 32", fill: "currentColor" }, rest, { style: __assign(__assign({}, (inline && INLINE_STYLES)), rest.style) }),
        title && React.createElement("title", null, title),
        React.createElement("path", { d: "M16 29.333c-7.364 0-13.333-5.97-13.333-13.333s5.97-13.333 13.333-13.333c7.364 0 13.333 5.97 13.333 13.333v0c0 7.364-5.97 13.333-13.333 13.333v0zM16 5.333c-5.891 0-10.667 4.776-10.667 10.667s4.776 10.667 10.667 10.667c5.891 0 10.667-4.776 10.667-10.667v0c0-5.891-4.776-10.667-10.667-10.667v0z" }),
        React.createElement("path", { d: "M14.667 16l2.667-1.333v9.333h-2.667v-8zM14.667 9.333l2.667-1.333v4h-2.667v-2.667z" })));
};
export default IconS24InfoCircle24;
//# sourceMappingURL=IconS24InfoCircle24.js.map